module.exports = __webpack_public_path__ + "static/img/Party-Off.52fcf779.svg";